<ng-container *transloco="let t;">
  <div>
    <ng-content />

    @if (subtitle()) {
      <div class="description text-muted mt-1" [innerHTML]="subtitle() | safeHtml"></div>
    }
  </div>
</ng-container>
